import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "empty-cart"
};
const _hoisted_2 = {
  key: 0,
  class: "empty-cart-left"
};
const _hoisted_3 = {
  class: "empty-cart-left-alerts"
};
const _hoisted_4 = {
  key: 1,
  class: "empty-cart-body"
};
const _hoisted_5 = {
  class: "empty-cart-body-title"
};
const _hoisted_6 = {
  class: "empty-cart-body-search"
};
const _hoisted_7 = {
  class: "empty-cart-body-options"
};
const _hoisted_8 = {
  class: "empty-cart-body-options-title"
};
const _hoisted_9 = {
  class: "empty-cart-body-options-span"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  class: "empty-cart-body-options-span"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  class: "empty-cart-body-options-span"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "empty-cart-right-rail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CartAlertBox = _resolveComponent("CartAlertBox");
  const _component_Search = _resolveComponent("Search");
  const _component_OrderSummary = _resolveComponent("OrderSummary");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.apiCallFailure ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_CartAlertBox, {
    unableToComplete: $props.apiCallFailure
  }, null, 8, ["unableToComplete"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString($options.getI18nMessage('cart.emptyCart.title')), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_Search, {
    activeTab: "#t=Products",
    altPlaceholderText: "productSearchHelpText"
  })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, _toDisplayString($options.getI18nMessage('cart.emptyCart.msg.part2') + " " + $options.getI18nMessage('myaccount.myItems')), 1), _createElementVNode("span", _hoisted_9, [_createElementVNode("a", {
    class: "empty-cart-body-options-span-link",
    href: $data.previousPurchasesURL
  }, _toDisplayString($options.getI18nMessage('cart.emptyCart.link.part0')), 9, _hoisted_10)]), _createElementVNode("span", _hoisted_11, [_createElementVNode("a", {
    class: "empty-cart-body-options-span-link",
    href: $data.partNumbersURL
  }, _toDisplayString($options.getI18nMessage('cart.emptyCart.link.part1')), 9, _hoisted_12)]), _createElementVNode("span", _hoisted_13, [_createElementVNode("a", {
    class: "empty-cart-body-options-span-link",
    href: $data.favoritesURL
  }, _toDisplayString($options.getI18nMessage('cart.emptyCart.link.part2')), 9, _hoisted_14)])])])), _createElementVNode("div", _hoisted_15, [_createVNode(_component_OrderSummary)])])]);
}